module.exports = __webpack_public_path__ + "static/img/znsy_p2.9ca2a1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/znsy_p2.png
// module id = 0zXh
// module chunks = 19